import React from 'react';
import {Link} from 'react-router';
import mode_toggle from '../static/images/mode-toggle-small.gif';

const Explainer = ({setExplainer, changeActiveYear, changeActiveMode, changeActivePrice, changeActiveProbability, setActiveNeighborhood, setBoroughFilter, setActiveHex, neighborhoods_samples}) => {

  const handleCloseClick = () => {
    setExplainer(false);
  }

  const stopPropagation = (e) => {
    e.stopPropagation();
  }

  const prospectHeights2010 = () => {
    if (neighborhoods_samples) {
      setExplainer(false);
      setActiveNeighborhood('Prospect Heights');
      changeActiveYear(2010);
      changeActivePrice(1000000);
      changeActiveMode('Chance');
    }
  }

  const prospectHeights2016 = () => {
    if (neighborhoods_samples) {
      setExplainer(false);
      setActiveNeighborhood('Prospect Heights');
      changeActivePrice(1000000);
      changeActiveMode('Chance');
      changeActiveYear(2016);
    }
  }

  const manhattan2016 = () => {
    if (neighborhoods_samples) {
      setExplainer(false);
      setBoroughFilter('manhattan')
      changeActivePrice(1500000);
      changeActiveMode('Chance');
      changeActiveYear(2016);
    }
  }

  const cobble2016 = () => {
    if (neighborhoods_samples) {
      setExplainer(false);
      setBoroughFilter(false)
      changeActivePrice(1500000);
      changeActiveMode('Price');
      setActiveNeighborhood('Brooklyn Heights-Cobble Hill');
      changeActiveYear(2016);
    }
  }

  const village2016 = () => {
    if (neighborhoods_samples) {
      setExplainer(false);
      setBoroughFilter(false)
      changeActivePrice(1500000);
      changeActiveMode('Price');
      setActiveNeighborhood('West Village');
      changeActiveYear(2016);
    }
  }

  const astoria2016 = () => {
    if (neighborhoods_samples) {
      setExplainer(false);
      setBoroughFilter(false)
      changeActivePrice(1000000);
      changeActiveMode('Chance');
      setActiveNeighborhood('Astoria');
      changeActiveYear(2016);
    }
  }

  const bedfor2018 = () => {
    if (neighborhoods_samples) {
      setExplainer(false);
      setBoroughFilter(false)
      changeActiveMode('Price');
      setActiveNeighborhood('Bedford');
      changeActiveYear(2018);
    }
  }

  let map_ready = false;
  if (neighborhoods_samples) map_ready = true;

  return (
    <div className={"ExplainBacker fixed left-0 top-0 right-0 bottom-0 " + (map_ready ? 'map_ready' : '')}           onClick={handleCloseClick.bind(this)}>
      <div className="ExplainInner h4 relative" onClick={stopPropagation.bind(this)}>
        <div className="h2 mb1 bold" style={{paddingRight: '2rem'}}>Probabilistic Real Estate</div>
        <div className="absolute center pointer"
          style={{
            right: '1.5rem',
            top: '0.8rem',
            height: '2rem',
            lineHeight: '2rem',
            fontSize: '2.5rem',
            color: '#666'
          }}
          onClick={handleCloseClick.bind(this)}
        >&times;</div>
        <p>Probabilistic Real Estate is a probabilistic programming prototype built by <a href="http://www.fastforwardlabs.com/">Fast Forward Labs</a> to accompany <a href="http://blog.fastforwardlabs.com">our report on probabilistic programming</a>. This prototype predicts future real estate prices across the New York City boroughs. It enables you to input your housing budget and shows you the probability of finding properties in that price range across different neighborhoods and future time periods.</p>
        <div className="h3 bold">Questions it Can Answer</div>
        <p className="h5 italic" style={{margin: '0.5rem 0 -0.5rem'}}>Click on a link below to view the visualization of the answer. You can return to these questions by clicking the question mark in the top right corner of the sidebar.</p>
        <p style={{marginBottom: '0'}}>You can use the prototype to answer questions such as:</p>
        <ul style={{marginTop: '0.5rem'}}>
          <li>What is the probability you could have afforded a property <Link to="/probability/1000000-50/2010/all_boroughs/prospect_heights">in Prospect Heights, Brooklyn in 2010 if you had $1m dollars</Link>? What is it <Link to="/probability/1000000-50/2016/all_boroughs/prospect_heights">in 2016</Link>?</li>
          <li>If you have $1.5m in 2016, <Link to="/probability/1500000-50/2016/manhattan/all_neighborhoods">in what Manhattan neighborhood are you most likely to find a property you can afford</Link>?</li>
          <li>How much money would you need to have an reasonable (medium) probability of affording a property <Link to="/price/50-1000000/2010/all_boroughs/brooklyn_heights-cobble_hill">in Brooklyn Heights-Cobble Hill, Brooklyn in 2016</Link>? How about <Link to="/price/50-1000000/2010/all_boroughs/west_village">in the West Village</Link>?</li>
          <li>In what part of Astoria, Queens are you <Link to="/probability/1000000-50/2016/all_boroughs/astoria/18966">most likely to be able to find a property for $1m in 2016</Link>?</li>
          <li>If current trends continue, how much would you need to have a reasonable (medium) chance of affording a property <Link to="/price/50-1000000/2018/all_boroughs/bedford">in Bedford, Brooklyn in 2018</Link>? How does that compare to past years?</li>
        </ul>
        <div className="h3 bold" style={{marginBottom: '-0.5rem'}}>Feature Overview</div>
        <img src={mode_toggle} className="col-12 mt2" style={{marginTop: '1.5rem'}} />
        <p className="h5 italic mt2" style={{marginTop: '0.5rem'}}>Use the mode toggle to switch between probability and price mode.</p>
        <p><strong>Probability mode</strong> let's you input a price and see the likelihood that you will be able to afford a property in a neighborhood. Switching to <strong>price mode</strong> lets you choose a probability (low, medium or high) and see the price required for that probability in each neighborhood. You can click on a neighborhood to see more information about the probabilities and prices. Once you have chosen a neighborhood you can get an even more detailed view by choosing a hex area within that neighborhood.</p>
        <p>The year selector in the bottom right lets you see how probabilities and prices have changed in the past and how our model predicts they will change in the future. Note that the predictions for 2016–2018 assume that past trends continue.</p>
      </div>
    </div>
  )

}

export default Explainer;


/** WEBPACK FOOTER **
 ** ./src/components/Explainer.js
 **/